const getters = {
  active: state => state.common.active,
  token: state => state.common.token
}
export default getters